import {
    useIntegrationMoySkladSetup,
    useIntegrationOzonSetup,
    useIntegrationWildberriesSetup,
    useIntegrationYamlGetSetup,
    useIntegrationYandexMarketSetup,
} from '../api';

export const useIntegrationTypeData = () => {
    const { data: wildberriesData } = useIntegrationWildberriesSetup();
    const { data: moySkladData } = useIntegrationMoySkladSetup();
    const { data: ozonData } = useIntegrationOzonSetup();
    const { data: ymlData } = useIntegrationYamlGetSetup();
    const { data: yandexMarketData } = useIntegrationYandexMarketSetup();

    return {
        wildberriesData,
        moySkladData,
        ozonData,
        ymlData,
        yandexMarketData,
    };
};
